import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            requireAuth: true
        },
        redirect: "/home/homePage",
        children: [
            // 我的项目
            {
                path: 'myProject',
                name: 'myProject',
                component: () => import('@/views/page/myProject'),
                redirect: "/myProject/allProject",
                children: [{
                    path: '/myProject/allProject',
                    name: 'allProject',
                    component: () => import('@/views/multiplex/project/allProject'),
                },
                    {
                        path: '/myProject/myProjectList',
                        name: 'myProjectList',
                        component: () => import('@/views/multiplex/project/myProject')
                    },
                    {
                        path: '/myProject/closedProject',
                        name: 'closedProject',
                        component: () => import('@/views/multiplex/project/closedProject')
                    },
                    {
                        path: '/myProject/myParticipate',
                        name: 'myParticipate',
                        component: () => import('@/views/multiplex/project/myParticipate')
                    }
                ]
            },
            {
                path: '/myProject/myProjectDetail',
                name: 'myProjectDetail',
                component: () => import('@/views/multiplex/project/components/allProjectDetail'),
            },

            // 模型库
            {
                path: 'ModelBase',
                name: 'ModelBase',
                component: () => import('@/views/page/ModelBase'),
                meta: {
                    requireAuth: true
                },
                redirect: "/ModelBase/allProcess",
                children: [
                    //所有流程
                    {
                        path: '/modelBase/allProcess',
                        name: 'allModel',
                        component: () => import('@/views/multiplex/modelPage/allProcess')
                    },
                    //通用流程
                    {
                        path: '/modelBase/universalProcess',
                        name: 'universalProcess',
                        component: () => import('@/views/multiplex/modelPage/universalProcess')
                    },
                    //经典流程
                    {
                        path: '/modelBase/classicProcess',
                        name: 'classicProcess',
                        component: () => import('@/views/multiplex/modelPage/classicProcess')
                    },
                    //共享流程
                    {
                        path: '/modelBase/sharedProcess',
                        name: 'sharedProcess',
                        component: () => import('@/views/multiplex/modelPage/sharedProcess')
                    },
                    //我的流程
                    {
                        path: '/modelBase/myProcess',
                        name: 'myProcess',
                        component: () => import('@/views/multiplex/modelPage/myProcess')
                    }
                ]

            },
            //流程详情页面
            {
                path: '/modelBase/processDetail',
                name: 'processDetail',
                component: () => import('@/views/multiplex/modelPage/components/processDetail'),
            },
            //数据空间
            {
                path: 'DataSpace',
                name: 'DataSpace',
                component: () => import('@/views/page/DataSpace'),
                meta: {
                    requireAuth: true
                },
                redirect: "/dataSpace/allData",
                children: [
                    //所有数据
                    {
                        path: '/dataSpace/allData',
                        name: 'allData',
                        component: () => import('@/views/multiplex/dataSpace/allData')
                    },
                    //公共数据
                    {
                        path: '/dataSpace/publicData',
                        name: 'publicData',
                        component: () => import('@/views/multiplex/dataSpace/publicData')
                    },
                    //团队数据
                    {
                        path: '/dataSpace/teamData',
                        name: 'teamData',
                        component: () => import('@/views/multiplex/dataSpace/teamData')
                    },
                    //团队数据
                    {
                        path: '/dataSpace/myData',
                        name: 'myData',
                        component: () => import('@/views/multiplex/dataSpace/myData')
                    }
                ]
            },
            //数据空间详情页面
            {
                path: '/dataSpace/dataDetail',
                name: 'dataDetail',
                component: () => import('@/views/multiplex/dataSpace/components/dataDetail'),
            },
            // 工具
            {
                path: 'ToolPage',
                name: 'ToolPage',
                component: () => import('@/views/page/toolPage'),
                meta: {
                    requireAuth: true
                }
            },
            // 组织
            {
                path: 'Organization',
                name: 'Organization',
                component: () => import('@/views/page/organization'),
                meta: {
                    requireAuth: true
                },
                redirect: '/Organization/framework',
                children: [{
                    path: 'Framework',
                    name: 'framework',
                    component: () => import('@/views/multiplex/organ/framework')
                },
                    {
                        path: 'Role',
                        name: 'role',
                        component: () => import('@/views/multiplex/organ/role')
                    }
                ]
            },
            // 消息
            {
                path: '/information',
                name: 'information',
                component: () => import('@/views/page/information'),
                redirect: '/information/allInformation',
                children: [
                    {
                        path: '/information/allInformation',
                        name: 'allInformation',
                        component: () => import('@/views/multiplex/allInform/allInformation')
                    },
                    {
                        path: '/information/haveRead',
                        name: 'haveRead',
                        component: () => import('@/views/multiplex/allInform/haveRead')
                    },
                    {
                        path: '/information/unread',
                        name: 'unread',
                        component: () => import('@/views/multiplex/allInform/unread')
                    },
                ]
            },
            {
                path: 'downLoad',
                name: 'downLoad',
                component: () => import('@/views/multiplex/downLoadList/index')
            }
        ]
    },
    //PGS-server
    {
        path: '/PGSPage',
        name: 'PGSPage',
        component: () => import('@/views/PGSPage/index'),
    },


    // {
    // 	path: '/login',
    // 	name: 'login',
    // 	component: () => import('@/views/login/index')
    // },
    //新增企业
    {
        path: '/NewEnterprise',
        name: 'NewEnterprise',
        component: () => import('@/views/page/newEnterprise'),
    },
    // 注册
    {
        path: '/activeAccount',
        name: 'activeAccount',
        component: () => import('@/views/activeAccount')
    },

    // 首页
    {
        path: '/home',
        name: 'home',
        redirect: "/home/newHome",
        component: () => import('@/views/page/home'),
        children: [
            {
                path: '/home/homePage',
                name: 'homePage',
                component: () => import('@/views/multiplex/homePage/threeHome'),
                meta: {
                    requireAuth: true
                }
            },
            //contact
            {
                path: '/home/contact',
                name: 'contact',
                component: () => import('@/views/multiplex/homePage/contact'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/home/tutorial',
                name: 'tutorial',
                component: () => import('@/views/multiplex/homePage/tutorial'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/tutorial/Introduction',
                name: 'Introduction',
                component: () => import('@/views/multiplex/homePage/Introduction'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/tutorial/LoginSRT-Server',
                name: 'LoginSRT-Server',
                component: () => import('@/views/multiplex/homePage/LoginSRT-Server'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/tutorial/TenModules',
                name: 'NineModules',
                component: () => import('@/views/multiplex/homePage/NineModules'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: '/tutorial/Miscellanea',
                name: 'Miscellanea',
                component: () => import('@/views/multiplex/homePage/Miscellanea'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/register',
                name: 'register',
                component: () => import('@/views/login/userRegister')
            },
            //cookie 协议
            {
                path: '/userAgreement',
                name: 'userAgreement',
                component: () => import('@/views/login/userAgreement')
            },
            // 登录
            {
                path: '/login',
                name: 'login',
                component: () => import('@/views/login/userLogin')
            },
            //技术中心
            {
                path: '/home/technologyCenter',
                name: 'technologyCenter',
                component: () => import('@/views/multiplex/homePage/technologyCenter'),
                meta: {
                    requireAuth: true
                }
            },
            // 服务与支持
            {
                path: '/home/serviceSupport',
                name: 'serviceSupport',
                component: () => import('@/views/multiplex/homePage/serviceSupport'),
                meta: {
                    requireAuth: true
                }
            },
            //数据库资源
            {
                path: '/home/dataBaseQuery',
                name: 'dataBaseQuery',
                component: () => import('@/views/multiplex/homePage/dataBaseQuery'),
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/home/technologyCenter',
                name: 'technologyCenter',
                component: () => import('@/views/multiplex/homePage/technologyCenter'),
                meta: {
                    requireAuth: true
                }
            },
            //经典案例
            {
                path: '/home/classicCase',
                name: 'classicCase',
                component: () => import('@/views/multiplex/homePage/classicCase'),
                meta: {
                    requireAuth: true
                }

            },
            //数据中心
            {
                path: '/home/dataContent',
                name: 'dataContent',
                component: () => import('@/views/multiplex/homePage/dataContent'),
                meta: {
                    requireAuth: true
                }
            },
            //home
            {
                path: '/home/newHome',
                name: 'newHome',
                component: () => import('@/views/multiplex/homePage/threeHome'),
                meta: {
                    requireAuth: true
                }
            },
            //home
            {
                path: '/home/exampleData',
                name: 'data',
                component: () => import('@/views/multiplex/homePage/exampleData'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/exampleData/quickStart',
                name: 'quickStart',
                component: () => import('@/views/multiplex/homePage/quickStart'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/exampleData/caseStudy',
                name: 'caseStudy',
                component: () => import('@/views/multiplex/homePage/caseStudy'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/exampleData/caseStudyMerfish',
                name: 'caseStudyMerfish',
                component: () => import('@/views/multiplex/homePage/caseStudyMerfish'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/exampleData/mouseBrain',
                name: 'mouseBrain',
                component: () => import('@/views/multiplex/homePage/mouseBrain'),
                meta: {
                    requireAuth: true
                }
            },
        ]
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
},
    router.beforeEach((to, from, next) => {
        next();
        // let token = window.sessionStorage.getItem('token')
        // if (to.meta.requireAuth) {
        // 	if (token == null || token == '') {
        // 		next({ path: '/login' })
        // 	} else {
        // 		next()
        // 	}
        // } else {
        // 	next();
        // }

    })
export default router;
